/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';

import type { BadgeProps } from '../../types';
import './Badge.less';

const Badge = ({ variant = 'default', size = 'medium', className, children }: BadgeProps) => (
  <span className={cx('ds-badge', `ds-badge--${variant}`, `ds-badge--${size}`, className)}>{children}</span>
);

Badge.displayName = 'Badge';

export default Badge;
